export function getPolygonscanTxUrl(txHash: string) {
  return `${getBaseUrl()}/tx/${txHash}`
}

export function getPolygonscanNftTokenUrl(txHash: string, tokenId: string) {
  return `${getBaseUrl()}/nft/${txHash}/${tokenId}`
}

export function getPolygonscanAddressUrl(address: string) {
  return `${getBaseUrl()}/address/${address}`
}

function getBaseUrl() {
  return process.env.REACT_APP_EXPLORER_BASE_URL
}
